import React, { useState } from "react";
import { FaMoneyBillWave, FaCar, FaCubes, FaPaw, FaUtensils, FaChevronDown } from "react-icons/fa";
import { useTripContext } from "../TripContext";
import SummaryCars from "./SummaryCars";
import SummaryElements from "./SummaryElements";
import SummaryFinance from "./SummaryFinance";
import SummaryPets from "./SummaryPets";
import SummaryFood from "./SummaryFood";
import "../../../css/View/Summary.css";
import { groupRegistrations } from "../../../utils/VariantRegistrationsUtils";

export const Summary = () => {
  const { tripData } = useTripContext();
  const { registrations, variants, elements } = tripData;
  const [activeView, setActiveView] = useState("finance");
  const [selectedVariantGuid, setSelectedVariantGuid] = useState(variants[0]?.guid || "");

  const selectedVariant = variants.find(v => v.guid === selectedVariantGuid);
  const grouped = groupRegistrations(registrations);
  const filteredRegistrations = grouped.active.filter(r => r.variantGuid === selectedVariantGuid);
  const filteredWaitlistRegistrations = grouped.waitlist.filter(r => r.variantGuid === selectedVariantGuid);
  const selectedElements = elements.filter(e => e.variants.includes(selectedVariantGuid));

  const views = [
    { key: "finance", label: "Koszty", icon: <FaMoneyBillWave /> },
    { key: "cars", label: "Samochody", icon: <FaCar /> },
    { key: "food", label: "Wyżywienie", icon: <FaUtensils /> },
    { key: "pets", label: "Zwierzęta", icon: <FaPaw /> },
    { key: "elements", label: "Zajętość elementów", icon: <FaCubes /> }
  ];

  return (
    <div className="summary-container">
      <div className="summary-toolbar">
        <div className="summary-variant-control">
          <span className="summary-toolbar-label">Wariant</span>
          <div className="summary-select-wrap">
            <select id="variant" value={selectedVariantGuid} onChange={(e) => setSelectedVariantGuid(e.target.value)}>
              {variants.map((variant) => <option key={variant.guid} value={variant.guid}>{variant.name}</option>)}
            </select>
            <FaChevronDown className="summary-select-chevron" />
          </div>
        </div>

        <div className="summary-view-tabs" role="tablist" aria-label="Rodzaj zestawienia">
          {views.map(view => (
            <button key={view.key} type="button" role="tab" aria-selected={activeView === view.key} className={`summary-view-tab ${activeView === view.key ? "summary-view-tab--active" : ""}`} onClick={() => setActiveView(view.key)}>
              <span className="summary-view-tab-icon">{view.icon}</span>
              <span>{view.label}</span>
            </button>
          ))}
        </div>
      </div>

      <div className="summary-content">
        {activeView === "cars" && <SummaryCars registrations={filteredRegistrations} waitlistRegistrations={filteredWaitlistRegistrations} />}
        {activeView === "elements" && <SummaryElements elements={selectedElements} variant={selectedVariant} registrations={filteredRegistrations} allVariants={variants} />}
        {activeView === "finance" && <SummaryFinance variant={selectedVariant} elements={selectedElements} />}
        {activeView === "food" && <SummaryFood registrations={filteredRegistrations} />}
        {activeView === "pets" && <SummaryPets registrations={filteredRegistrations} />}
      </div>
    </div>
  );
};

export default Summary;
